import React, { useState } from "react";
import bg from "../../assets/bg2.png";
import { Box, Paper, TextField } from "@mui/material";
import CustomBox from "../components/Box/CustomBox";
import AddGuestInput from "../components/InputField/AddGuestInput";
import CustomButton from "../components/Button/CustomButton";
import nhance from "../../assets/Common/nhance_logo.png";
import SearchablePhoneInput from "../components/InputField/SearchablePhoneInput";
import emailValidator from "email-validator";
import { setNavigation } from "../redux/slice/NavigationSlice";
import { useDispatch, useSelector } from "react-redux";
import { startGenerateOtp } from "../redux/slice/TenantSlice";
import { NavigationConstants } from "../common/Constants";
import { resetAlert, setToastMessage } from "../redux/slice/Common/toastSlice";
import BackgroundImage from "../components/BackgroundImage/BackgroundImage";
import OverlayLoader from "../components/Overlay/OverlayLoader";
import { getRelativeHeight } from "../utils/RelativeSize";

const fieldGap = 1.25;

const UserLoginScreen = () => {
  const dispatch = useDispatch();
  const hashValue = useSelector((state) => state?.tenantConfig?.hashValue);
  const { logo } = useSelector((state) => state?.tenantConfig);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleChangeName = (e) => {
    const val = e.target.value;
    setName(val);
    validateForm(val, email);
  };

  const handleChangeEmail = (e) => {
    const val = e.target.value;
    setEmail(val);
    if (val.length === 0) {
      setEmailError(false);
    } else {
      setEmailError(!validateEmail(val));
    }

    validateForm(name, val);
  };

  const validateForm = (name, email) => {
    const isNameValid = /^[a-zA-Z ]+$/.test(name.trim());
    const isNameInvalid =
      !isNameValid || /[!@#$%^&*(),.?":{}|<>0-9]/.test(name);

    const isEmailValid =
      email.length > 1 ? emailValidator.validate(email) : true;
    const isNameLengthZero = name.length === 0;
    setIsFormValid(isNameValid && !isNameInvalid && isEmailValid);

    setNameError(!isNameLengthZero && isNameInvalid);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleLoader = () => {
    setLoader((prev) => !prev);
  };

  const handleChangePhone = (value, { isValid } = {}) => {
    if (!value) {
      setPhone("");
      setIsPhoneValid(false);
      return;
    }
    setPhone(value);
    setIsPhoneValid(Boolean(isValid));
  };

  const handleNavigate = () => {
    dispatch(setNavigation(NavigationConstants?.OTP_INPUT));
    dispatch(
      setToastMessage({ message: "OTP sent successfully", type: "success" })
    );
    setTimeout(() => {
      dispatch(resetAlert());
    }, 3000);
  };
  const handleSubmit = () => {
    handleLoader();
    let data = {
      hashValue,
      userName: name,
    };
    if (email) {
      data.email = email;
    }

    if (phone) {
      data.mobile = phone;
    }
    dispatch(
      startGenerateOtp({
        data,
        handleSuccess: handleNavigate,
        handleLoader: handleLoader,
      })
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100%",
      }}
    >
      <BackgroundImage imageUrl={bg} poweredByLogo={nhance} Logo={logo}>
        <CustomBox>
          <Paper
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "380px",
              top: "50%",
              outline: "0",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 4,
              p: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: fieldGap,
              }}
            >
              <AddGuestInput
                placeholder="Name"
                height="6vh"
                name="name"
                value={name}
                onChange={handleChangeName}
                isError={nameError}
                helperText={
                  nameError ? "Please enter a valid name." : ""
                }
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={handleChangeEmail}
                error={emailError}
                helperText={emailError ? "Invalid email address" : ""}
                FormHelperTextProps={{
                  sx: { mx: 0, mt: 0.25, fontSize: 12, lineHeight: 1.2 },
                }}
                sx={{ mt: 0.75 }}
              />
              <SearchablePhoneInput
                defaultCountry="IN"
                preferredCountries={["IN", "GB", "SG"]}
                value={phone}
                onChange={handleChangePhone}
                height="6vh"
              />

              <CustomBox sx={{ width: "100%" }}>
                <CustomButton
                  height={getRelativeHeight(60)}
                  title="Generate OTP"
                  onClick={handleSubmit}
                  disabled={!isFormValid || !isPhoneValid}
                />
              </CustomBox>
            </Box>
          </Paper>
        </CustomBox>
        <OverlayLoader visible={loader} />
      </BackgroundImage>
    </Box>
  );
};

export default UserLoginScreen;
